<template>

<div class="col-12 md:col-12 justify-content-center" >

	        <CardProcesso :processo="processo"/>

			<CardTimeline :processo="processo"/>




			<div  v-if="temProcessos" class="card col-12 md:col-12 mt-1 mb-1 justify-content-center">

				<DataTable :value="processo.selecaoEstagioArea"
							class="p-datatable-lg p-datatable-gridlines p-datatable-striped "
							dataKey="id">

					<template #header>
						<div class="table-header">
							Áreas e quantidade de vagas
						</div>
					</template>

					<Column field="nome" header="Área" headerStyle="width: 50%">
						<template #body="slotProps">
							{{slotProps.data.area.nome}}
							<p v-if="slotProps.data.vagas===0" class="font-bold">(Cadastro de Reserva)</p>
						</template>
					</Column>

					<Column header="Total de vagas">
						<template #body="slotProps">
							{{slotProps.data.totalVagas}}
						</template>
					</Column>

					<Column field="vagas" header="Vagas ampla concorrência"/>

					<Column header="Vagas convênio">
						<template #body="slotProps">
							{{slotProps.data.vagasConvenio ? slotProps.data.vagasConvenio : 0}}
						</template>
					</Column>

					<Column field="reservadas" header="Vagas estudantes com deficiência"/>

				</DataTable>
			</div>

	<CardEstatisticas  v-if="temProcessos" :processo="processo"/>

</div>

</template>

<script>
import CardEstatisticas from '../components/CardEstatisticas.vue';
import CardProcesso from '../components/CardProcesso.vue';
import CardTimeline from './CardTimeline.vue';
import ProcessoService from "../service/ProcessoService";

	export default {

  		components: { CardEstatisticas ,CardProcesso, CardTimeline},

		data() {
			return {
				selectedArea: null,
				token: this.$store.state.token,
				habilitaInscricoes: false,
				temProcessos:false,
	            processo: {
					id: null,
                	nome: '',
					datHoraInicioInscricao: '',
					datHoraFimInscricao: '',
					coeficienteMinimo: null,
					areas: [],
					estadoSelecao:{
						cod:0
					}
				},
				inscricoes: [],
				perfil: '',
				processoService: null,
			}
		},

		created() {
			this.processoService = new ProcessoService();
			this.carregarProcesso();
		},

		computed: {
    		processoSelecionado: {
      			get() {
        			return this.$store.state.processoSelecionado;
      			},
			}
		},

		watch:{
			processoSelecionado() {
				this.carregarProcesso();
			}
		},

		methods: {
			carregarProcesso() {
				if ( this.processoSelecionado ) {
					this.processoService.getProcesso(this.processoSelecionado.id)
					.then(resposta => {
						this.processo = resposta;
						this.habilitaInscricoes = this.inscricoesEmAberto();
						this.processo.datHoraFimInscricao = this.$formatarDataHoraBR(this.processo.datHoraFimInscricao);
						this.processo.datHoraInicioInscricao = this.$formatarDataHoraBR(this.processo.datHoraInicioInscricao);
						this.temProcessos = true;
					});
				}
			},
			inscricoesEmAberto() {
				return this.processoSelecionado.abertoParaInscricao;
  			},
			findIndexById(id) {
				let index = -1;
				for (let i = 0; i < this.inscricoes.length; i++) {
					if (this.inscricoes[i].id.selecaoEstagio.id === id) {
						index = i;
						break;
					}
				}
				return index;
			}

		}
	}


</script>
